import { Injectable } from '@angular/core';
import { STORAGE_KEYS } from '../constants/storage-keys.const';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  get userInfoToken() {
    return sessionStorage.getItem(STORAGE_KEYS.ARP_TOKEN);
  }

  get localUserInfoToken() {
    return localStorage.getItem(STORAGE_KEYS.ARP_TOKEN);
  }

  set userInfoToken(token: string | null) {
    sessionStorage.setItem(STORAGE_KEYS.ARP_TOKEN, token || '');
    localStorage.setItem(STORAGE_KEYS.ARP_TOKEN, token || '');
  }

  get offPlatformSecretKey() {
    return sessionStorage.getItem(STORAGE_KEYS.OFF_PLATFORM_SECRET);
  }

  set offPlatformSecretKey(token: string | null) {
    sessionStorage.setItem(STORAGE_KEYS.OFF_PLATFORM_SECRET, token || '');
  }

  constructor() {
    // Expire stored ARP credentials after eight hours.
    setInterval(
      () => {
        sessionStorage.removeItem(STORAGE_KEYS.ARP_TOKEN);
        localStorage.removeItem(STORAGE_KEYS.ARP_TOKEN);
      },
      1000 * 60 * 60 * 8
    );
  }
}
